import { useEffect, useRef } from 'react';

const SESSION_EXPIRY_CHECK_INTERVAL = 5000;

/**
 * Sets up an interval to periodically check for session expiry.
 *
 * @param url url
 * @param authContext
 */
export function useSessionExpiry(url, authContext, sessionExpiryCheck) {
    const authContextRef = useRef(authContext);

    // updating the auth context reference on value change
    useEffect(() => {
        authContextRef.current = authContext;
    }, [authContext]);

    // setting periodic session expiry check on first render
    useEffect(() => {
        const interval = setInterval(() => {
            if (!authContextRef.current.auth.isExpired) {
                sessionExpiryCheck(url, authContextRef.current);
            }
        }, SESSION_EXPIRY_CHECK_INTERVAL);

        return () => clearInterval(interval);
    }, []);
}
